import { Icon, IconButton, TextField } from '@atom/mui';
import { CloseIcon, SearchIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

const styles = {
  container: {
    width: '21.875rem',
  },
  input: {
    backgroundColor: colors.neutral.typhoon,
    height: '2.125rem',
    padding: '0 0.625rem',
    borderRadius: '0.25rem',
  },
};

type SearchBoxProps = {
  value: string;
  onChange: (value: string) => void;
};

const SearchBox = ({ value, onChange }: SearchBoxProps) => {
  return (
    <TextField
      style={styles.container}
      placeholder="Search"
      value={value}
      onChange={event => onChange(event.target.value)}
      slotProps={{
        input: {
          disableUnderline: true,
          sx: styles.input,
          startAdornment: <Icon icon={SearchIcon} />,
          endAdornment: value ? (
            <IconButton
              onClick={() => onChange('')}
              size="small"
              data-cy="filesTabSearchBoxClear"
            >
              <Icon icon={CloseIcon} />
            </IconButton>
          ) : undefined,
        },
      }}
      data-cy="filesTabSearchBoxInput"
    />
  );
};

export default SearchBox;
